import type { CSSProperties, FC } from 'react'
import { useCallback } from 'react'
import { NavLink } from 'react-router-dom'
import type { NavLinkFnProps } from '../root'

export enum NavBarItem {
    Members,
    DataSets,
    WorkOrderManufacturer,
    WorkOrderModel,
    WorkOrderModelManufacturer,
    QueueTasks,
    InvitationCodes,
    Profile,
    Domains,
    Grants,
    FeatureFlags,
    ViPrompt,
}

const nameByItem: Record<NavBarItem, string> = {
    [NavBarItem.Members]: 'Members',
    [NavBarItem.DataSets]: 'Data sets',
    [NavBarItem.WorkOrderManufacturer]: 'WO Manufacturer Match',
    [NavBarItem.WorkOrderModel]: 'WO Model Match',
    [NavBarItem.WorkOrderModelManufacturer]:
        'WO Model Manufacturer Match (New)',
    [NavBarItem.QueueTasks]: 'Tasks',
    [NavBarItem.InvitationCodes]: 'Invitation codes',
    [NavBarItem.Profile]: 'Profile',
    [NavBarItem.Domains]: 'Domains',
    [NavBarItem.Grants]: 'Data grants',
    [NavBarItem.FeatureFlags]: 'Feature flags',
    [NavBarItem.ViPrompt]: 'Vi 3.0 prompt',
}

const routeByItem: Record<NavBarItem, string> = {
    [NavBarItem.Members]: 'members',
    [NavBarItem.DataSets]: 'data-sets',
    [NavBarItem.WorkOrderManufacturer]: 'wo-manufacturer-match',
    [NavBarItem.WorkOrderModel]: 'wo-model-match',
    [NavBarItem.WorkOrderModelManufacturer]: 'wo-model-manufacturer-match',
    [NavBarItem.QueueTasks]: 'tasks',
    [NavBarItem.InvitationCodes]: 'invitation-codes',
    [NavBarItem.Profile]: 'profile',
    [NavBarItem.Domains]: 'domains',
    [NavBarItem.Grants]: 'data-grants',
    [NavBarItem.FeatureFlags]: 'feature-flags',
    [NavBarItem.ViPrompt]: 'vi-prompt',
}

export interface NavBarProps {
    style?: CSSProperties
}

export const NavBar: FC<NavBarProps> = ({ style }) => {
    const items = [
        NavBarItem.Members,
        NavBarItem.DataSets,
        NavBarItem.WorkOrderManufacturer,
        NavBarItem.WorkOrderModel,
        NavBarItem.WorkOrderModelManufacturer,
        NavBarItem.QueueTasks,
        NavBarItem.InvitationCodes,
        NavBarItem.Profile,
        NavBarItem.Domains,
        NavBarItem.Grants,
        NavBarItem.FeatureFlags,
        NavBarItem.ViPrompt,
    ]

    const itemClassName = useCallback(({ isActive }: NavLinkFnProps) => {
        return isActive ? 'active' : ''
    }, [])

    return (
        <div className="navbar" style={style}>
            {items.map((item) => (
                <span key={item}>
                    <NavLink to={routeByItem[item]} className={itemClassName}>
                        {nameByItem[item]}
                    </NavLink>
                </span>
            ))}
        </div>
    )
}
